import { Component, Inject, Renderer2, ViewChild, ViewContainerRef, DOCUMENT } from '@angular/core'
import { CurrentUser } from './shared/services/current-user'
import { LayoutsService, LayoutTypes } from './shared/services/layouts'
import './shared/extensions/date.extensions'
import './shared/extensions/number.extensions'
import { WebsocketService } from './shared/services/websocket'
import { WebsocketMapperService } from './shared/services/websocket/websocket-mapper.service'

import { VersionCheckService } from './shared/services/version-check/version-check.service'
import { environment } from '@env/environment'
import { YMService } from './shared/services/ym/ym.service'
import { Observable } from 'rxjs'
import { TOP_BANNER_BODY_CLASS, TopBannerService } from './shared/services/top-banner'
import { UTMService } from './shared/services/utm/utm.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public currentUser: CurrentUser,
    private layoutsService: LayoutsService,
    public viewContainerRef: ViewContainerRef,
    private renderer: Renderer2,
    private websocketService: WebsocketService,
    private websocketMapperService: WebsocketMapperService,
    private versionCheckService: VersionCheckService,
    private topBannerService: TopBannerService,
    private ym: YMService,
    private utmService: UTMService
  ) {
    this.window = this.document.defaultView!.window
  }
  @ViewChild('toaster', { read: ViewContainerRef }) toaster: ViewContainerRef

  title = 'Глабикс'
  layoutTypes = LayoutTypes
  activeLayout: LayoutTypes
  window: Window
  topBannerState$: Observable<boolean> = this.topBannerService.getState()

  ngOnInit() {
    this.initLayout()
    this.websocketService.on().subscribe((msg) => {
      this.websocketMapperService.map(msg)
    })
    this.utmService.init()

    if (environment.production) {
      this.versionCheckService.init()

      if (!Object.keys(this.currentUser).length) {
        this.ym.init()
      }
    }
  }

  private initLayout(): void {
    this.layoutsService.get().subscribe((layout) => {
      if (this.activeLayout != layout) {
        this.activeLayout = layout
        this.toggleBodyClass()
        this.toggleNavbar()
      }
    })
  }

  private toggleBodyClass(): void {
    if (
      [
        LayoutTypes.REGISTRATION_BLANK,
        LayoutTypes.REGISTRATION_EMPTY,
        LayoutTypes.REGISTRATION_SIMPLE,
        LayoutTypes.ADMIN,
      ].includes(this.activeLayout)
    ) {
      this.renderer.addClass(document.children[0], 'body-registration-layout')
    } else {
      this.renderer.removeClass(document.children[0], 'body-registration-layout')
    }

    if (![LayoutTypes.APP].includes(this.activeLayout)) {
      this.renderer.removeClass(document.body, TOP_BANNER_BODY_CLASS)
    }
  }

  private toggleNavbar(): void {
    if (this.activeLayout === LayoutTypes.APP && this.window.innerWidth <= 1280) {
      this.renderer.addClass(document.body, 'body-navbar--collapsed')
    }
  }
}
